import {TokenVerify} from './commands/token-verify';
import {TokenVerifyResponse} from './protocol/token-verify-req';
import {BaseApiWrapper} from '../base-api-wrapper';
import {MarketingDataType} from './protocol/marketing-data';
import {RegistrationWithPassword} from './commands/registration-with-password';
import {RegistrationResponse} from './protocol/registration-req';
import {RegistrationWithConfirmation} from './commands/registration-with-confirmation';
import {RegistrationEmailOnly} from './commands/registration-email-only';
import {CheckEmailAvailableResponse} from './protocol/check-email-available-req';
import {CheckEmailAvailable} from './commands/check-email-available';
import {GetPolicy} from './commands/get-policy';
import {GetPolicyResponse} from './protocol/get-policy-req';
import {GetTokenByContinuePlayingUrlResponse} from './protocol/get-token-by-continue-playing-url-req';
import {GetTokenByContinuePlayingUrl} from './commands/get-token-by-continue-playing-url';
import {GetGameStartData} from './commands/get-game-start-data';
import {GetGameStartDataRequest, GetGameStartDataResponse} from './protocol/get-game-start-data-request';

export class HubApi extends BaseApiWrapper {
    private url: string;

    public constructor(url: string) {
        super();
        this.url = url;
    }

    public verifyToken(token: string): Promise<TokenVerifyResponse> {
        const params = {
            token
        };
        const cmd = new TokenVerify(this.url, params);
        this.setCmdAdapters(cmd);
        return cmd.run();
    }

    // eslint-disable-next-line max-params
    public registrationWithPassword(
        deviceIdentifier: string,
        email: string,
        password: string,
        current_entry_point: string,
        locale: string,
        state?: string,
        confidence?: string | number,
        marketingData?: MarketingDataType
    ): Promise<RegistrationResponse> {
        const params = {
            confidence,
            current_entry_point,
            email,
            locale,
            marketingData,
            password,
            state
        };
        const cmd = new RegistrationWithPassword(this.url, deviceIdentifier, params);
        this.setCmdAdapters(cmd);
        return cmd.run();
    }

    // eslint-disable-next-line max-params
    public registrationWithConfirmation(
        deviceIdentifier: string,
        email: string,
        email_confirm: string,
        current_entry_point: string,
        locale: string,
        state?: string,
        confidence?: string | number,
        marketingData?: MarketingDataType
    ): Promise<RegistrationResponse> {
        const params = {
            confidence,
            current_entry_point,
            email,
            email_confirm,
            locale,
            marketingData,
            state
        };
        const cmd = new RegistrationWithConfirmation(this.url, deviceIdentifier, params);
        this.setCmdAdapters(cmd);
        return cmd.run();
    }

    // eslint-disable-next-line max-params
    public registrationEmailOnly(
        deviceIdentifier: string,
        email: string,
        current_entry_point: string,
        locale: string,
        state?: string,
        confidence?: string | number,
        marketingData?: MarketingDataType
    ): Promise<RegistrationResponse> {
        const params = {
            confidence,
            current_entry_point,
            email,
            locale,
            marketingData,
            state
        };
        const cmd = new RegistrationEmailOnly(this.url, deviceIdentifier, params);
        this.setCmdAdapters(cmd);
        return cmd.run();
    }

    public checkEmailAvailable(deviceIdentifier: string, email: string): Promise<CheckEmailAvailableResponse> {
        const params = {
            email
        };
        const cmd = new CheckEmailAvailable(this.url, deviceIdentifier, params);
        this.setCmdAdapters(cmd);
        return cmd.run();
    }

    public getPolicy(
        deviceIdentifier: string,
        lang: string,
        policyName: string,
        policyVersion?: number
    ): Promise<GetPolicyResponse> {
        const params = {
            lang,
            policyName,
            policyVersion
        };
        const cmd = new GetPolicy(this.url, deviceIdentifier, params);
        this.setCmdAdapters(cmd);
        return cmd.run();
    }

    public getTokenByContinuePlayingUrl(
        deviceIdentifier: string,
        email: string,
        expires: number,
        token: string,
        currentEntryPoint: string
    ): Promise<GetTokenByContinuePlayingUrlResponse> {
        const params = {
            currentEntryPoint,
            email,
            expires,
            token
        };
        const cmd = new GetTokenByContinuePlayingUrl(this.url, deviceIdentifier, params);
        this.setCmdAdapters(cmd);
        return cmd.run();
    }

    public getGameStartData(
        deviceIdentifier: string,
        params: GetGameStartDataRequest
    ): Promise<GetGameStartDataResponse> {
        const cmd = new GetGameStartData(this.url, deviceIdentifier, params);
        this.setCmdAdapters(cmd);
        return cmd.run();
    }
}
